var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[(_vm.loading)?_c('div',[_c('p',[_vm._v("Loading chart data...")])]):_vm._e(),(!_vm.loading && _vm.chartDataAvailable)?_c('highcharts',{ref:"highcharts",attrs:{"options":_vm.chartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }